import { render, staticRenderFns } from "./TarefaAssociacoesPage.vue?vue&type=template&id=1c3b882c"
import script from "./TarefaAssociacoesPage.vue?vue&type=script&lang=js"
export * from "./TarefaAssociacoesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports